// Actions
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

// Initial State
export const dialogInitial = {
  open: false
};

// Reducer
export function dialog(state, action) {
  if (!state) {
    state = dialogInitial;
  }
  switch (action.type) {
    case OPEN_DIALOG:
      return { ...state, open: true, ...action.payload };
    case CLOSE_DIALOG:
      return { open: false };
    default:
      return state;
  }
}

// Action Creators
export function openDialog(payload) {
  return { type: OPEN_DIALOG, payload };
}

export function closeDialog() {
  return { type: CLOSE_DIALOG };
}
